import React from 'react';
import { StyleSheet, Platform, View } from 'react-native';
export const TileContainer = ({ children, }) => {
    if (Platform.OS === 'web') {
        return (React.createElement(View, { style: styles.flatlist }, children));
    }
    else {
        return React.createElement(React.Fragment, null, children);
    }
};
const styles = StyleSheet.create({
    flatlist: Platform.select({
        web: {
            height: 'calc(100vh - var(--nav-bar-height) - var(--mini-player-height))',
            maxHeight: '100vh',
        },
        default: {},
    }),
});
//# sourceMappingURL=TileContainer.js.map